<section id="chess" class="section" appReveal>
  <p class="eyebrow mb-2">Off the clock</p>
  <div class="mb-8 flex flex-wrap items-end justify-between gap-4">
    <h2 class="section-title">Chess</h2>
    <input
      type="text"
      [(ngModel)]="filteredPlayer"
      placeholder="Filter player…"
      class="input max-w-xs"
    />
  </div>

  <!-- Players -->
  <div class="card overflow-hidden p-0">
    <div class="border-b border-slate-200 px-5 py-3 text-sm font-semibold text-cyan-600 dark:border-white/10 dark:text-cyan-400">
      Troy Chess League
    </div>
    <div class="overflow-x-auto">
      <table class="w-full text-left text-sm">
        <thead class="text-xs uppercase tracking-wide text-slate-500 dark:text-slate-400">
          <tr class="border-b border-slate-200 dark:border-white/10">
            <th class="px-5 py-3">Player</th>
            <th class="px-3 py-3">Blitz</th>
            <th class="px-3 py-3">Bullet</th>
            <th class="px-3 py-3">Puzzle</th>
            <th class="px-3 py-3">Rapid</th>
            <th class="px-3 py-3">Spent (d)</th>
            <th class="px-3 py-3">Seen</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let user of users | filter:filteredPlayer:'username'; let i = index"
            (click)="selectedUser(user.username)"
            class="cursor-pointer border-b border-slate-100 transition hover:bg-slate-50 dark:border-white/5 dark:hover:bg-white/5"
            title="click for the games!"
          >
            <td class="px-5 py-3 font-medium">
              <i class="fas fa-chess-king mr-2 text-cyan-500"></i>{{ i + 1 }}.
              <span [class.text-emerald-500]="user.online" [class.font-semibold]="user.online">{{ user.username | shorten:14 }}</span>
            </td>
            <td class="px-3 py-3" [title]="'Rapid: ' + user.rapid + ' · Classical: ' + user.classical + ' · Puzzle: ' + user.puzzle">{{ user.blitz }}</td>
            <td class="px-3 py-3">{{ user.bullet }}</td>
            <td class="px-3 py-3">{{ user.puzzle }}</td>
            <td class="px-3 py-3">{{ user.rapid }}</td>
            <td class="px-3 py-3">{{ user.playTime / (3600 * 24) | number:'1.0-2' }}</td>
            <td class="px-3 py-3 text-slate-500 dark:text-slate-400" [title]="user.seenAt | date:'short'">{{ user.seenAt | date:'H:mm · MMM d' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Games of selected player -->
  <div *ngIf="selectedGames?.length" class="card mt-6 overflow-hidden p-0">
    <div class="border-b border-slate-200 px-5 py-3 text-sm font-semibold text-cyan-600 dark:border-white/10 dark:text-cyan-400">
      Recent games
    </div>
    <div class="overflow-x-auto">
      <table class="w-full text-left text-sm">
        <thead class="text-xs uppercase tracking-wide text-slate-500 dark:text-slate-400">
          <tr class="border-b border-slate-200 dark:border-white/10">
            <th class="px-5 py-3">White vs Black</th>
            <th class="px-3 py-3">Winner</th>
            <th class="px-3 py-3">Clock</th>
            <th class="px-3 py-3">Opening</th>
            <th class="px-3 py-3">Time</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let game of selectedGames" class="border-b border-slate-100 dark:border-white/5">
            <td class="px-5 py-3">
              <button
                type="button"
                (click)="openModal(game.id)"
                class="text-left font-medium text-slate-800 transition hover:text-cyan-600 dark:text-slate-100 dark:hover:text-cyan-400"
              >
                {{ game.players['white'].user.id | shorten:6 }}({{ game.players['white'].rating }})
                vs
                {{ game.players['black'].user.id | shorten:6 }}({{ game.players['black'].rating }})
              </button>
            </td>
            <td class="px-3 py-3">
              {{ game.winner }}
              <span class="chip ml-1 text-xs">{{ game.speed | shorten:8 }}</span>
            </td>
            <td class="px-3 py-3">{{ game.clock.initial / 60 }} + {{ game.clock.increment }}</td>
            <td class="px-3 py-3 text-slate-500 dark:text-slate-400" [title]="game.opening.eco + ': ' + game.opening.name">{{ game.opening.name | shorten:22 }}</td>
            <td class="px-3 py-3 text-slate-500 dark:text-slate-400" [title]="game.lastMoveAt | date:'short'">{{ game.lastMoveAt | date:'H:mm · MMM d' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Game modal (Angular-controlled, replaces the old Bootstrap modal) -->
  <div
    *ngIf="showModal"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm"
    (click)="closeModal()"
  >
    <div
      class="relative w-full max-w-md rounded-2xl border border-white/10 bg-[#12141a] p-4 shadow-2xl"
      (click)="$event.stopPropagation()"
    >
      <button
        type="button"
        (click)="closeModal()"
        class="absolute right-3 top-3 grid h-8 w-8 place-items-center rounded-lg text-slate-300 hover:bg-white/10"
        aria-label="Close"
      >
        <i class="fas fa-xmark"></i>
      </button>
      <div class="mt-6 overflow-hidden rounded-lg">
        <iframe
          width="400"
          height="400"
          frameborder="0"
          class="mx-auto block max-w-full"
          [src]="this.choosenGame | sanitizer"
        ></iframe>
      </div>
    </div>
  </div>
</section>
